import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';
import InvoicesSubscriptionContainer from './invoices/subscription/InvoiceSubscriptionContainer';

const invoicesSubscriptionErb = document.getElementById('invoices-subscription');

if (invoicesSubscriptionErb != null) {

  const root = createRoot(invoicesSubscriptionErb);
  root.render(
    <ThemeProvider theme={ProduttivoMuiTheme}>
      <InvoicesSubscriptionContainer />
    </ThemeProvider>
  );
}